import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getFaqCategoriesByEventId = (request) => {
    return vdkEmHappinessPortalApi.post('/faq-categories/get-by-event-id', request);
};
const getFaqsByEventIdForRegistration = (request) => {
    return vdkEmHappinessPortalApi.post('/faq/registration/get-by-event', request);
};
const getFaqCategoryById = (request) => {
    return vdkEmHappinessPortalApi.post('/faq-categories/get-by-id', request);
};
const createFaqCategory = (request) => {
    return vdkEmHappinessPortalApi.post('/faq-categories/create', request);
};
const updateFaqCategory = (request) => {
    return vdkEmHappinessPortalApi.put('/faq-categories/update', request);
};
const deleteFaqCategory = (request) => {
    return vdkEmHappinessPortalApi.delete('/faq-categories/delete', {
        data: request
    });
};
const reorderFaqCategories = (request) => {
    return vdkEmHappinessPortalApi.put('/faq-categories/reorder', request);
};
const faqCategoryApi = {
    getFaqCategoriesByEventId,
    getFaqsByEventIdForRegistration,
    getFaqCategoryById,
    createFaqCategory,
    updateFaqCategory,
    deleteFaqCategory,
    reorderFaqCategories
};
export default faqCategoryApi;
